import React, { useState } from 'react';
import { Check } from 'lucide-react';
export const AIFormTest = () => {
  const [formStep, setFormStep] = useState(1);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    // Page 1
    fullName: '',
    email: '',
    phone: '',
    profession: '',
    cityState: '',
    hasCreatedWebsite: '',
    aiComfortLevel: '',
    device: [] as string[],
    learningGoal: [] as string[],
    biggestFrustration: [] as string[],
    oneThingToWalkAway: '',
    // Page 2
    interestInMasterclass: '',
    priceWillingness: '',
    investmentFactor: [] as string[],
    monetizationIntent: '',
    audienceToServe: [] as string[],
    monthlyIncomeGoal: '',
    preferredClassStyle: '',
    preferredClassTime: [] as string[],
    practicePreference: [] as string[],
    paymentPlanHelp: '',
    permissionForUpdates: ''
  });
  const handleFormChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => {
        const currentArray = prev[name as keyof typeof prev] as string[];
        if (checked) {
          return {
            ...prev,
            [name]: [...currentArray, value]
          };
        } else {
          return {
            ...prev,
            [name]: currentArray.filter(item => item !== value)
          };
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleNextStep = () => {
    setFormStep(2);
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    const data = {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      profession: formData.profession,
      city: formData.cityState,
      websiteExperience: formData.hasCreatedWebsite,
      aiComfort: formData.aiComfortLevel,
      device: Array.isArray(formData.device) ? formData.device.join(', ') : formData.device,
      goal: Array.isArray(formData.learningGoal) ? formData.learningGoal.join(', ') : formData.learningGoal,
      frustration: Array.isArray(formData.biggestFrustration) ? formData.biggestFrustration.join(', ') : formData.biggestFrustration,
      oneThing: formData.oneThingToWalkAway,
      masterclassInterest: formData.interestInMasterclass,
      priceRange: formData.priceWillingness,
      investTrigger: Array.isArray(formData.investmentFactor) ? formData.investmentFactor.join(', ') : formData.investmentFactor,
      monetize: formData.monetizationIntent,
      audience: Array.isArray(formData.audienceToServe) ? formData.audienceToServe.join(', ') : formData.audienceToServe,
      monthlyGoal: formData.monthlyIncomeGoal,
      classStyle: formData.preferredClassStyle,
      classTime: Array.isArray(formData.preferredClassTime) ? formData.preferredClassTime.join(', ') : formData.preferredClassTime,
      practicePreference: Array.isArray(formData.practicePreference) ? formData.practicePreference.join(', ') : formData.practicePreference,
      paymentPlan: formData.paymentPlanHelp,
      permission: formData.permissionForUpdates
    };
    console.log('Submitting data:', data);
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbx3X11ZnhJ9Qas0Ylp8l7U1OHsjyTtx-u-Zp-mhsA3blmP3aIJBhB4TfhcLmnSFAgtg5A/exec', {
        method: 'POST',
        body: JSON.stringify(data)
      });
      const result = await response.json();
      console.log('Response:', result);
      if (result.result === 'success') {
        setSubmitStatus('success');
        // Redirect to WhatsApp group after successful submission
        setTimeout(() => {
          window.location.href = 'https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee';
        }, 2000);
      } else {
        setSubmitStatus('error');
        alert('Submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
      alert('Submission failed. Please try again.');
    }
  };
  if (submitStatus === 'success') {
    return <div className="min-h-screen flex items-center justify-center" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-1659" data-mp="3nk4t5srl72h1">
        <div className="text-center p-8" data-id="element-1660" data-mp="k5ikte3b8s76">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#1AB9C8'
        }} data-id="element-1661" data-mp="k4fwndxdh3uy">
            <Check size={40} style={{
            color: '#FFFFFF'
          }} data-id="element-1662" data-mp="a7b4mxguie68" />
          </div>
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-1663" data-mp="669gbbogvmj1">
            Form Submitted Successfully!
          </h1>
          <p className="text-lg mb-4" style={{
          color: '#333333'
        }} data-id="element-1664" data-mp="2uzd8u8pmzcm0">
            Data has been sent to Google Sheets.
          </p>
          <p style={{
          color: '#333333'
        }} data-id="element-1665" data-mp="16efx2cznbxm2">
            Redirecting to WhatsApp...
          </p>
        </div>
      </div>;
  }
  return <div className="min-h-screen py-12" style={{
    backgroundColor: '#F9F9F9'
  }} data-id="element-1666" data-mp="1agauv7idbsv3">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-1667" data-mp="1fe2me0f3pcyr">
        <div className="mb-8 text-center" data-id="element-1668" data-mp="1k5kqgxcf7tny">
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-1669" data-mp="1k6cixzaq1ba0">
            AI Power Bundle Form Test
          </h1>
          <p className="text-lg" style={{
          color: '#333333'
        }} data-id="element-1670" data-mp="1u3qnp1na8bmh">
            Testing Google Sheets Integration
          </p>
        </div>

        {/* Progress Bar */}
        <div className="mb-8" data-id="element-1671" data-mp="1y3j05pfsr1x4">
          <div className="h-2 rounded-full" style={{
          backgroundColor: '#E5E5E5'
        }} data-id="element-1672" data-mp="234yktge2b6ez">
            <div className="h-full rounded-full transition-all duration-300" style={{
            backgroundColor: '#F4B400',
            width: formStep === 1 ? '50%' : '100%'
          }} data-id="element-1673" data-mp="3rul7n9kezcq" />
          </div>
          <p className="text-center mt-2 text-sm" style={{
          color: '#333333'
        }} data-id="element-1674" data-mp="1c0jnme878jbm">
            Step {formStep} of 2
          </p>
        </div>

        <form id="aiForm" onSubmit={formStep === 2 ? handleFormSubmit : e => {
        e.preventDefault();
        handleNextStep();
      }} className="space-y-6 p-8 rounded-lg" style={{
        backgroundColor: '#FFFFFF',
        border: '2px solid #E5E5E5'
      }} data-id="element-1675" data-mp="174l3x3xtfphj">
          {formStep === 1 ? <>
              <h2 className="text-2xl font-bold mb-6" style={{
            color: '#0B1F3F'
          }} data-id="element-1676" data-mp="1q14619a7cd4l">
                Basic Info & Digital Readiness
              </h2>

              <div data-id="element-1677" data-mp="23rpo4vru0j1f">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1678" data-mp="23uc0d8po3mpz">
                  Full Name *
                </label>
                <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1679" data-mp="2dr6xbn6alf25" />
              </div>

              <div data-id="element-1680" data-mp="2xcgr77t47hp2">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1681" data-mp="2xd0b2u2bsg5q">
                  Email Address *
                </label>
                <input type="email" name="email" value={formData.email} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1682" data-mp="2neasez2lurof" />
              </div>

              <div data-id="element-1683" data-mp="2eduqhu1ifslo">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1684" data-mp="2eee8tbv2oj08">
                  Phone Number *
                </label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1685" data-mp="24n9wkjws7c93" />
              </div>

              <div data-id="element-1686" data-mp="1uoc0mvx10gg2">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1687" data-mp="1uou6mk9hq916">
                  Current Profession *
                </label>
                <input type="text" name="profession" value={formData.profession} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1688" data-mp="267cudd09hjrl" />
              </div>

              <div data-id="element-1689" data-mp="1wa83izvh104g">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1690" data-mp="1s60ibco822az">
                  City/State *
                </label>
                <input type="text" name="cityState" value={formData.cityState} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1691" data-mp="1ndh54gtg596p" />
              </div>

              <div data-id="element-1692" data-mp="18it2rbjceqvb">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1693" data-mp="18gzr1htvhggg">
                  Have you ever created a website before? *
                </label>
                <select name="hasCreatedWebsite" value={formData.hasCreatedWebsite} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1694" data-mp="3g2zxqi7eqzcb">
                  <option value="" data-id="element-1695" data-mp="3p5iuckklofq4">Select...</option>
                  <option value="Yes" data-id="element-1696" data-mp="3u4c9ehfjcese">Yes</option>
                  <option value="No" data-id="element-1697" data-mp="3u3142d6fyyz6">No</option>
                </select>
              </div>

              <div data-id="element-1698" data-mp="2whvetjy6sfac">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1699" data-mp="2we7iye59rgsg">
                  Comfort level with AI tools *
                </label>
                <select name="aiComfortLevel" value={formData.aiComfortLevel} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1700" data-mp="36c5771n4pdl2">
                  <option value="" data-id="element-1701" data-mp="2dnq3hb9g6hp1">Select...</option>
                  <option value="Beginner" data-id="element-1702" data-mp="2incj1rcr0a10">Beginner</option>
                  <option value="Intermediate" data-id="element-1703" data-mp="34jfcthpw9nac">Intermediate</option>
                  <option value="Advanced" data-id="element-1704" data-mp="34l9os6j6u52a">Advanced</option>
                </select>
              </div>

              <div data-id="element-1705" data-mp="39kctfpv9a99q">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1706" data-mp="3ehcybxgdd5z9">
                  Device you work with? * (Select all that apply)
                </label>
                <div className="space-y-2" data-id="element-1707" data-mp="2lsxpjsntzjwd">
                  {['Laptop (Windows)', 'Laptop (Mac)', 'Desktop Computer', 'Tablet', 'Smartphone Only', 'Smartphone + occasional laptop access', 'I currently have no device'].map(option => <label key={option} className="flex items-center" data-id="element-1708" data-mp="2vqliqe5sgjcf">
                      <input type="checkbox" name="device" value={option} checked={formData.device.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-1709" data-mp="30hlgtmqn97gi" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1710" data-mp="231xss5a3h5sj">
                        {option}
                      </span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-1711" data-mp="p3tudo17279p">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1712" data-mp="l4ughdxhj064">
                  What exactly do you want to achieve with this AI Skills Class?
                  * (Choose one or multiple)
                </label>
                <div className="space-y-2" data-id="element-1713" data-mp="b8hn6h5uqobw">
                  {['Learn how to use AI for everyday productivity', 'Automate repetitive tasks in my work/business', 'Learn how to use AI tools for content creation', 'Build AI-powered workflows (emails, proposals, research, etc.)', 'Create digital products/services using AI', 'Improve my career or become more employable', 'Start a freelance or consulting business using AI', 'Learn how to train or specialize AI for my field', 'Understand AI well enough to teach others', 'Not sure yet — I just want to learn'].map(option => <label key={option} className="flex items-center" data-id="element-1714" data-mp="3emu4r619enf0">
                      <input type="checkbox" name="learningGoal" value={option} checked={formData.learningGoal.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-1715" data-mp="34zrk1i2hhyjj" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1716" data-mp="39whzc36gsq3w">
                        {option}
                      </span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-1717" data-mp="3nq9a1evxmg17">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1718" data-mp="3nppq5smq1hkj">
                  Biggest frustration with learning digital skills? * (Select up
                  to 4)
                </label>
                <div className="space-y-2" data-id="element-1719" data-mp="3exfhwgvdzm5x">
                  {["Too much information — I don't know where to start", 'No one to guide me step-by-step', "I learn but I can't apply it practically", "I don't have enough time", 'Tools feel too complex', 'Training programs are too expensive', 'I learn fast but forget when I try to do it alone', 'My device is slow or limited', 'Poor internet connection', "I'm overwhelmed… everything feels new"].map(option => <label key={option} className="flex items-center" data-id="element-1720" data-mp="1v1rwdt23xwil">
                      <input type="checkbox" name="biggestFrustration" value={option} checked={formData.biggestFrustration.includes(option)} onChange={handleFormChange} disabled={formData.biggestFrustration.length >= 4 && !formData.biggestFrustration.includes(option)} className="mr-2" data-id="element-1721" data-mp="1uznrb7sh2rgq" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1722" data-mp="1h3tggj851s0z">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1723" data-mp="1qxts73xxdvio">
                  Selected: {formData.biggestFrustration.length}/4
                </p>
              </div>

              <div data-id="element-1724" data-mp="32h68ougmjgy7">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1725" data-mp="2xg8v6v6k7b31">
                  If you could walk away from this class with ONE thing fully
                  done, what would it be? * (Pick only 1)
                </label>
                <select name="oneThingToWalkAway" value={formData.oneThingToWalkAway} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1726" data-mp="1c02fka62au70">
                  <option value="" data-id="element-1727" data-mp="1pxzcx8scb4mq">Select one...</option>
                  <option value="My first automated workflow" data-id="element-1728" data-mp="1px7qangq0h8l">
                    My first automated workflow
                  </option>
                  <option value="My first AI-created digital product" data-id="element-1729" data-mp="1znj02qn35kne">
                    My first AI-created digital product
                  </option>
                  <option value="My personal AI assistant set up" data-id="element-1730" data-mp="23omct49u70ke">
                    My personal AI assistant set up
                  </option>
                  <option value="My business processes automated" data-id="element-1731" data-mp="2dn24p9gouduy">
                    My business processes automated
                  </option>
                  <option value="My AI portfolio built" data-id="element-1732" data-mp="2ns1pmiypyovd">
                    My AI portfolio built
                  </option>
                  <option value="My AI content creation system" data-id="element-1733" data-mp="2iu8mxzwmkczu">
                    My AI content creation system
                  </option>
                  <option value="My first AI-powered income stream" data-id="element-1734" data-mp="29rz9p29z25ir">
                    My first AI-powered income stream
                  </option>
                  <option value="My resume/LinkedIn profile optimized with AI" data-id="element-1735" data-mp="36gyo6z15g3je">
                    My resume/LinkedIn profile optimized with AI
                  </option>
                  <option value="My business marketing system automated" data-id="element-1736" data-mp="2wqm3n6tc4ad9">
                    My business marketing system automated
                  </option>
                  <option value="Clarity and confidence using AI tools" data-id="element-1737" data-mp="3p7zih9rbrawm">
                    Clarity and confidence using AI tools
                  </option>
                  <option value="A full 30-day action plan I can follow" data-id="element-1738" data-mp="3kg80voq5cfim">
                    A full 30-day action plan I can follow
                  </option>
                  <option value="Not sure — I want recommendations" data-id="element-1739" data-mp="1njbqjztz9nds">
                    Not sure — I want recommendations
                  </option>
                </select>
              </div>

              <button type="submit" className="w-full py-4 rounded-md font-bold text-white text-lg transition-all hover:opacity-90" style={{
            backgroundColor: '#0B1F3F'
          }} data-id="element-1740" data-mp="1dsqt4fq1iowg">
                Next →
              </button>
            </> : <>
              <h2 className="text-2xl font-bold mb-6" style={{
            color: '#0B1F3F'
          }} data-id="element-1741" data-mp="14qhou7ld7rri">
                Buying Power & Learning Style
              </h2>

              <div data-id="element-1742" data-mp="uuwpyiblf7lz">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1743" data-mp="uwharg83vc6n">
                  Interest in full practical masterclass *
                </label>
                <select name="interestInMasterclass" value={formData.interestInMasterclass} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1744" data-mp="2p6bgv2gcbd3b">
                  <option value="" data-id="element-1745" data-mp="nalu7ogmezzw">Select...</option>
                  <option value="Very Interested" data-id="element-1746" data-mp="ncgi9bn6v887">Very Interested</option>
                  <option value="Somewhat Interested" data-id="element-1747" data-mp="ij43dt8bafsn">
                    Somewhat Interested
                  </option>
                  <option value="Not Interested" data-id="element-1748" data-mp="w9z4ukghdum7">Not Interested</option>
                </select>
              </div>

              <div data-id="element-1749" data-mp="sc1fnhmpn8it">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1750" data-mp="169pxshpe81k6">
                  Price range you would consider? * (₦100,000–₦250,000)
                </label>
                <select name="priceWillingness" value={formData.priceWillingness} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1751" data-mp="380un373usq1c">
                  <option value="" data-id="element-1752" data-mp="2h9m2m4vu5cqn">Select...</option>
                  <option value="₦100,000 – ₦130,000" data-id="element-1753" data-mp="2h6zy6e48rdcn">
                    ₦100,000 – ₦130,000
                  </option>
                  <option value="₦130,000 – ₦160,000" data-id="element-1754" data-mp="2qyxcvuugkng4">
                    ₦130,000 – ₦160,000
                  </option>
                  <option value="₦160,000 – ₦190,000" data-id="element-1755" data-mp="2vy08ypsgnjby">
                    ₦160,000 – ₦190,000
                  </option>
                  <option value="₦190,000 – ₦220,000" data-id="element-1756" data-mp="1ybjavibwl1p5">
                    ₦190,000 – ₦220,000
                  </option>
                  <option value="₦220,000 – ₦250,000" data-id="element-1757" data-mp="23b5p9v3gwnzj">
                    ₦220,000 – ₦250,000
                  </option>
                  <option value="I can pay in installments" data-id="element-1758" data-mp="2d7915so4g0zo">
                    I can pay in installments
                  </option>
                  <option value="I can only join if there is a scholarship/discount" data-id="element-1759" data-mp="3jm9nd6nch4t2">
                    I can only join if there is a scholarship/discount
                  </option>
                </select>
              </div>

              <div data-id="element-1760" data-mp="1cy9aximlmmat">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1761" data-mp="1d0vihi9hp1t1">
                  What would make you confidently invest in a premium hands-on
                  program? * (Choose at most 2)
                </label>
                <div className="space-y-2" data-id="element-1762" data-mp="y9d1pi8t338m">
                  {['Step-by-step practical learning', 'Real-life projects I can use immediately', 'A mentor or expert I can ask questions', 'Templates, tools & resources included', 'A clear promise of skill mastery', 'Proof that others got results', 'Certificate + portfolio', 'Live sessions + recordings', 'Community support + accountability', 'Money-back guarantee', 'A clear path to earning with AI', 'Flexible payment options'].map(option => <label key={option} className="flex items-center" data-id="element-1763" data-mp="2eoo7cyknqapm">
                      <input type="checkbox" name="investmentFactor" value={option} checked={formData.investmentFactor.includes(option)} onChange={handleFormChange} disabled={formData.investmentFactor.length >= 2 && !formData.investmentFactor.includes(option)} className="mr-2" data-id="element-1764" data-mp="29pbi676bcrjv" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1765" data-mp="2wme2cueudm5e">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1766" data-mp="2msnjq65ec5xm">
                  Selected: {formData.investmentFactor.length}/2
                </p>
              </div>

              <div data-id="element-1767" data-mp="2dw65gu1qjrxn">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1768" data-mp="28ugrb5j7uy5c">
                  Do you want to use this skill to earn money? *
                </label>
                <select name="monetizationIntent" value={formData.monetizationIntent} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1769" data-mp="73vn25ppde6f">
                  <option value="" data-id="element-1770" data-mp="ak8b40hab2nu">Select...</option>
                  <option value="Yes" data-id="element-1771" data-mp="emv5a81fgzo7">Yes</option>
                  <option value="No" data-id="element-1772" data-mp="elk2aaft3vy5">No</option>
                  <option value="Maybe" data-id="element-1773" data-mp="jdl9vj214yhu">Maybe</option>
                </select>
              </div>

              <div data-id="element-1774" data-mp="jfxrtw7sf8uw">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1775" data-mp="od7mprdy4cq4">
                  Audience you plan to serve? * (Choose 2-3)
                </label>
                <div className="space-y-2" data-id="element-1776" data-mp="3rsv7aduz5fja">
                  {['Small business owners', 'Students / young people', 'Creatives (writers, designers, content creators)', 'NGOs / nonprofits', 'Coaches / consultants', 'Corporate teams', 'Schools / teachers', 'E-commerce businesses', 'Real estate', 'Health & wellness', 'Churches / ministries', 'Anyone who needs digital transformation', 'Not sure yet — I need help choosing'].map(option => <label key={option} className="flex items-center" data-id="element-1777" data-mp="1h0ajof2z4fe9">
                      <input type="checkbox" name="audienceToServe" value={option} checked={formData.audienceToServe.includes(option)} onChange={handleFormChange} disabled={formData.audienceToServe.length >= 3 && !formData.audienceToServe.includes(option)} className="mr-2" data-id="element-1778" data-mp="rcy3hxhgsm8l" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1779" data-mp="1191fdv24bz8q">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1780" data-mp="8kdmpef1i7l5">
                  Selected: {formData.audienceToServe.length}/3
                </p>
              </div>

              <div data-id="element-1781" data-mp="iecpmfmxtve5">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1782" data-mp="dm2xqu29il98">
                  Monthly income goal using AI-assisted skills *
                </label>
                <input type="text" name="monthlyIncomeGoal" value={formData.monthlyIncomeGoal} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1783" data-mp="3h31oto44f9x7" />
              </div>

              <div data-id="element-1784" data-mp="21ciqdpf3ovdq">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1785" data-mp="1mmbejsjlmam0">
                  Preferred class style *
                </label>
                <select name="preferredClassStyle" value={formData.preferredClassStyle} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1786" data-mp="1rjbkm3gg7dd4">
                  <option value="" data-id="element-1787" data-mp="26aanqyyil9pb">Select...</option>
                  <option value="Live" data-id="element-1788" data-mp="269r6zlklorcv">Live</option>
                  <option value="Recorded" data-id="element-1789" data-mp="2abm7woymd2q4">Recorded</option>
                  <option value="Hybrid" data-id="element-1790" data-mp="2aa2st1op8xpx">Hybrid</option>
                </select>
              </div>

              <div data-id="element-1791" data-mp="utu9h8yp4z41">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1792" data-mp="ywquf6bpl7b5">
                  Preferred Class Time * (Choose 2)
                </label>
                <div className="space-y-2" data-id="element-1793" data-mp="1f5ollwcodhxn">
                  {['Weekday mornings', 'Weekday afternoons', 'Weekday evenings', 'Saturday mornings', 'Saturday afternoons', 'Saturday evenings', 'Sunday afternoon', 'Fully online & flexible (self-paced + live support)'].map(option => <label key={option} className="flex items-center" data-id="element-1794" data-mp="10ga8qe9w4idi">
                      <input type="checkbox" name="preferredClassTime" value={option} checked={formData.preferredClassTime.includes(option)} onChange={handleFormChange} disabled={formData.preferredClassTime.length >= 2 && !formData.preferredClassTime.includes(option)} className="mr-2" data-id="element-1795" data-mp="1y3984wryw4f3" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1796" data-mp="1k3881jjj110o">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1797" data-mp="8n9vv6t1xyv8">
                  Selected: {formData.preferredClassTime.length}/2
                </p>
              </div>

              <div data-id="element-1798" data-mp="2oc8fflzj950a">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1799" data-mp="2odru585jj7zy">
                  How do you prefer to practice? * (Choose 2)
                </label>
                <div className="space-y-2" data-id="element-1800" data-mp="2y3l3e2i7nb11">
                  {['Guided step-by-step exercises', 'Real project challenges', 'Assignments with feedback', 'Interactive live sessions', 'Solo practice following templates', 'Group practice / paired learning', 'Watching video tutorials', 'Doing it myself with occasional support', 'A combination of everything'].map(option => <label key={option} className="flex items-center" data-id="element-1801" data-mp="3h1fagazs3cgs">
                      <input type="checkbox" name="practicePreference" value={option} checked={formData.practicePreference.includes(option)} onChange={handleFormChange} disabled={formData.practicePreference.length >= 2 && !formData.practicePreference.includes(option)} className="mr-2" data-id="element-1802" data-mp="3h0mb3v35fp8o" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1803" data-mp="2pyttnfubynym">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1804" data-mp="2z0jj4g4njctr">
                  Selected: {formData.practicePreference.length}/2
                </p>
              </div>

              <div data-id="element-1805" data-mp="38vbklv1cujtt">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1806" data-mp="38utg6b4jgzat">
                  If a payment plan would help you join faster *
                </label>
                <select name="paymentPlanHelp" value={formData.paymentPlanHelp} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1807" data-mp="3hrautoc43fbb">
                  <option value="" data-id="element-1808" data-mp="3moszh2j3j8di">Select...</option>
                  <option value="Yes" data-id="element-1809" data-mp="3mqdyb4cg1dh6">Yes</option>
                  <option value="No" data-id="element-1810" data-mp="a4fawlst3vdw">No</option>
                </select>
              </div>

              <div data-id="element-1811" data-mp="f3rumxodsmc9">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1812" data-mp="f4bbeb2ap4op">
                  Permission to receive updates on upcoming advanced
                  masterclasses *
                </label>
                <select name="permissionForUpdates" value={formData.permissionForUpdates} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1813" data-mp="57yllo9vfaz8">
                  <option value="" data-id="element-1814" data-mp="3dlxg0lh72oam">Select...</option>
                  <option value="Yes" data-id="element-1815" data-mp="3dn8lqqu7a64d">Yes</option>
                  <option value="No" data-id="element-1816" data-mp="3ikifgiomh3y0">No</option>
                </select>
              </div>

              <div className="flex gap-4" data-id="element-1817" data-mp="34kzdk7memou5">
                <button type="button" onClick={() => setFormStep(1)} className="flex-1 py-4 rounded-md font-bold transition-all hover:opacity-90" style={{
              backgroundColor: '#E5E5E5',
              color: '#333333'
            }} data-id="element-1818" data-mp="34mabvrx2z4dv">
                  ← Back
                </button>
                <button type="submit" disabled={submitStatus === 'submitting'} className="flex-1 py-4 rounded-md font-bold text-white transition-all hover:opacity-90" style={{
              backgroundColor: '#F4B400',
              opacity: submitStatus === 'submitting' ? 0.6 : 1
            }} data-id="element-1819" data-mp="3k41vbv2gcn2h">
                  {submitStatus === 'submitting' ? 'Submitting...' : 'Submit & Test'}
                </button>
              </div>
            </>}
        </form>
      </div>
    </div>;
};